import fetchLogger from "./fetchLogger";

/** PATCH /api/v1/issues/:id/resolve */
export default async function resolveIssue(id, resolutionNote) {
  const result = { return: 0, msg: "Failed resolving issue", data: null };

  const res = await fetchLogger({
    method: "PATCH",
    url: `/api/v1/issues/${id}/resolve`,
    data: { resolutionNote: resolutionNote || "" },
  });

  if (res.ok) {
    result.return = 1;
    result.msg = "Issue resolved";
    result.data = res.data?.data || null;
  } else {
    const message = res.data?.message;
    result.msg = Array.isArray(message) ? message.join(", ") : message || result.msg;
  }

  return result;
}
